/*eslint-disable*/
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// components
import { ReactComponent as HorizontalLogoBlue } from '../../assets/img/JUMO_Logo_dark.svg';

// styles
import '../../assets/styles/App.css';


export default function Navbar(props) {
  const [navbarOpen, setNavbarOpen] = useState(false);
    const [show, setShow] = useState(false);
    const [color, setColor] = useState(false);
    const [lastScrollY, setLastScrollY] = useState(0);

    const controlNavbar = () => {
        if (typeof window !== 'undefined') {
          if (window.scrollY <= 0) { // if scroll down hide the navbar
            setShow(false);
            setColor(false);
          } else if (window.scrollY > lastScrollY) { // if scroll down hide the navbar
            setShow(true);
          } else { // if scroll up show the navbar
            setShow(false);
    
            if (window.scrollY === 0) { // if scroll down hide the navbar
              setColor(false);
            } else if (window.scrollY < lastScrollY){
              setColor(true);
            } else {
              setColor(false);
            }
          }
    
          // remember current page location to use in the next move
          setLastScrollY(window.scrollY);
        }
      };

      useEffect(() => {
        if (typeof window !== 'undefined') {
          window.addEventListener('scroll', controlNavbar);
    
          // cleanup function
          return () => {
            window.removeEventListener('scroll', controlNavbar);
          };
        }
      }, [lastScrollY]);
    
      const smallLogo = (window.innerWidth < 768);

  return (
    <>
      <nav className="top-0 relative w-full flex flex-wrap items-center justify-between px-2 py-4 navbar-expand-lg text-white bg-white">
        <div className="container px-4 py-2 mx-auto rounded flex flex-wrap items-center justify-between navbar-white">
          <div className="w-full relative flex justify-between items-center lg:w-auto lg:static lg:block lg:justify-start">
            <Link
              className="leading-relaxed inline-block mr-4 pr-10"
              to="/"
            >
            { window.innerWidth < 768 ? (
                <HorizontalLogoBlue className="size-horizontal-logo-small" />
                ) : (
                <HorizontalLogoBlue className="size-horizontal-logo-large" />
                )
            }

            </Link>
            <button
              className="cursor-pointer leading-none px-3 py-2 border-0 rounded-full bg-yellow block lg:hidden outline-none h-burger"
              type="button"
              onClick={() => setNavbarOpen(!navbarOpen)}
            >
              <i className="text-blue fas fa-bars"></i>
            </button>
          </div>

          <div
            className={
              "lg:flex flex-grow items-center center md:bg-white lg:bg-opacity-0 " +
              (navbarOpen ? "block mt-8" : " hidden")
            }
            id="example-navbar-warning">
            <ul className="flex flex-col lg:flex-row list-none lg:ml-auto"
            >

              <li className="flex items-center hover:text-light-blue">
                <Link
                  className="text-16-500 py-3 inline-block mx-4 whitespace-nowrap"
                  href="https://jumo.world/"
                >
                  About JUMO
                </Link>
              </li>             

            </ul>
          </div>

          <div
              className={
                  "lg:flex flex-grow items-center lg:bg-opacity-0" +
                  (navbarOpen ? " block" : " hidden")
              }
              id="example-navbar-warning"
          >
                        <ul className="flex flex-col lg:flex-row list-none lg:ml-auto mt-2">
                  <li className="flex items-center">

                        <div className="items-center flex">
                          <Link
                              className={`text-16-500 py-2 hover:text-light-blue lg:mb-0 + ${(navbarOpen || color ) ? "text-blue" : "text-yellow"}`}
                              to="/"
                          >
                              <button
                                  className={"text-16-500 px-12 py-3 ml-3 mb-3 flex items-center rounded"
                                             + (navbarOpen ? "text-blue bg-yellow rounded" : "text-yellow")}
                                  type="button"
                                >
                                   &nbsp;&nbsp; Home &nbsp;&nbsp;
                              </button>
                          </Link>
                        </div>

                  </li>
                </ul>
           
          </div>
        </div>
      </nav>
    </>
  );
}
